/* eslint-disable no-restricted-syntax */
/* eslint-disable max-len */

import { CatalogTagsTranslation } from '../../modelViewer/Data/catalogTagsTranslation';
import { SLTXFile } from './sltxFile';

import { ModelTreeNode, ModelTreeNodeDataOption, ParsedTreeNodeType } from '../../modelConfiguration/data/modelOptionsTree';
// eslint-disable-next-line import/no-cycle
import { TreeBuilding } from '../../modelConfiguration/logic/treeBuilding';
import { TreeOptionSelection, TreeOptionSelections } from '../../modelConfiguration/data/optionsSelection';

export interface TreeOptionSeelctionWithName {
  optionGroupId: number,
  optionGroupName: string,
  optionId: number,
  optionName: string,

}
export class SLTXTranslations {

  // Group and option translation helpers
  static getTranslatedComponentName(componentId : number, sltxFile: SLTXFile, lang: string) : string {
    const groupObject = sltxFile?.getRootFileContents().groups?.find((group) => group.id === componentId);
    if (groupObject) return CatalogTagsTranslation.getTranslation(groupObject.tagTranslation, lang) || groupObject.name;
    return '<undefined-0>';
  }

  static getSelectedOptionTranslation(componentId: number, optionId: number, sltxFile: SLTXFile, translate: boolean, lang: string) : string {
    const groupObject = sltxFile?.getRootFileContents().groups?.find((group) => group.id === componentId);

    const selectedVariantComponentOption = optionId;

    let objectComponentOptionName = '';
    groupObject?.optionsFolders.forEach((of) => {
      const folderName = translate && of.tagTranslation ? CatalogTagsTranslation.getTranslation(of.tagTranslation, lang) : of.name;
      of.options.forEach((o) => {
        if (o.id === selectedVariantComponentOption) {
          const optionName = translate && o.tagTranslation ? CatalogTagsTranslation.getTranslation(o.tagTranslation, lang) : o.name;
          objectComponentOptionName = folderName === 'Root' ? `${optionName}` : `${folderName}+${optionName}`;
        }
      });
    });
    return objectComponentOptionName; // objectComponentOption ? objectComponentOption.name : '';
  }

  // Group and option plane name helpers
  static getComponentName(componentId : number, sltxFile: SLTXFile) : string {
    const groupObject = sltxFile?.getRootFileContents().groups?.find((group) => group.id === componentId);
    if (groupObject) return groupObject.name;
    return '<undefined-0>';
  }

  static getSelectedOptionName(componentId: number, optionId: number, sltxFile: SLTXFile) : string {
    const groupObject = sltxFile?.getRootFileContents().groups?.find((group) => group.id === componentId);

    const selectedVariantComponentOption = optionId;

    let objectComponentOptionName = '';
    groupObject?.optionsFolders.forEach((of) => {
      const folderName = of.name;
      of.options.forEach((o) => {
        if (o.id === selectedVariantComponentOption) {
          const optionName = o.name;
          objectComponentOptionName = folderName === 'Root' ? `${optionName}` : `${folderName}+${optionName}`;
        }
      });
    });
    return objectComponentOptionName; // objectComponentOption ? objectComponentOption.name : '';
  }

  static getSelectedLeafOptionName(componentId: number, optionId: number, sltxFile: SLTXFile) : string {
    const groupObject = sltxFile?.getRootFileContents().groups?.find((group) => group.id === componentId);

    const selectedVariantComponentOption = optionId;

    let objectComponentOptionName = '';
    groupObject?.optionsFolders.forEach((of) => {
      of.options.forEach((o) => {
        if (o.id === selectedVariantComponentOption) {
          const optionName = o.name;
          objectComponentOptionName = `${optionName}`;
        }
      });
    });
    return objectComponentOptionName; // objectComponentOption ? objectComponentOption.name : '';
  }

  static IsGroupNameVisible(groupName : string) : boolean {
    return !(!groupName.localeCompare('#N/D') || !groupName.localeCompare('#N/A'));
  }
  static IsGroupVisible(componentId : number, sltxFile: SLTXFile, lang: string) : boolean {
    const groupName = SLTXTranslations.getTranslatedComponentName(componentId, sltxFile, lang);
    return this.IsGroupNameVisible(groupName);
  }

  // ---------------------------------------------------------------------------------------
  // Eval all possible / allowed options given the current configuration and the model rules
  // ---------------------------------------------------------------------------------------
  static getAllValidOptions(sltxFile: SLTXFile, aComposition : TreeOptionSelections | undefined) : TreeOptionSeelctionWithName[] | undefined {

    const options: TreeOptionSeelctionWithName[] = [];

    function traverse(node: ModelTreeNode, aSltxFile : SLTXFile) {
      // Add current node's path if not empty
      if (node.path && node.path.trim() !== '') {
        const odata: ModelTreeNodeDataOption = node.data as ModelTreeNodeDataOption;
        if (odata && node.type === ParsedTreeNodeType.Option) {
          const gName = SLTXTranslations.getComponentName(odata.groupID, aSltxFile);
          const oName = SLTXTranslations.getSelectedOptionName(odata.groupID, node.id, aSltxFile);
          const opt: TreeOptionSeelctionWithName = {
            optionGroupId: odata.groupID, optionGroupName: gName, optionId: node.id, optionName: oName,
          };
          options.push(opt);
        }
      }

      // Recursively traverse children
      if (node.children && node.children.length > 0) {
        for (const child of node.children) {
          traverse(child, aSltxFile);
        }
      }
    }
    if (sltxFile && sltxFile.rules && aComposition) {
      const optionTree = TreeBuilding.buildTree(
        sltxFile.rules,
        sltxFile.getRootFileContents(),
        aComposition,
      );

      if (optionTree) {
        traverse(optionTree, sltxFile);
        options.sort((a, b) => (a.optionGroupId !== b.optionGroupId ? a.optionGroupId - b.optionGroupId : a.optionId - b.optionId));
        return options;
      }
    }
    return undefined;
  }

  // ---------------------------------------------------------------------------------------------
  // Convert configuration string to array of treeoptionselection
  // ---------------------------------------------------------------------------------------------
  static getTreeOptionSelectionFromConfigString(rawConfig: string, rawPreviousConfig: string) : TreeOptionSelections | undefined {
    const result: TreeOptionSelection[] = [];

    const addOption = (g: number, o: number) => {
      const exists = result.find((r) => r.groupID === g);
      if (exists === undefined) result.push({ groupID: g, optionID: o });
    };

    const config = decodeURIComponent(rawConfig);
    const groups = config.split('_');
    for (const group of groups) {
      const parts = group.split('-');
      if (parts.length === 2 && !Number.isNaN(Number(parts[0])) && !Number.isNaN(Number(parts[1]))) {
        addOption(Number(parts[0]), Number(parts[1]));
      }
    }
    const pconfig = decodeURIComponent(rawPreviousConfig);
    const pgroups = pconfig.split('_');
    for (const group of pgroups) {
      const parts = group.split('-');
      if (parts.length === 2 && !Number.isNaN(Number(parts[0])) && !Number.isNaN(Number(parts[1]))) {
        addOption(Number(parts[0]), Number(parts[1]));
      }
    }
    return result.length > 0 ? result : undefined;
  }
}
